import { udpApi } from 'yxt-biz-pc/packages/api';

// 获取岗位列表
export const getPositionList = (data) => {
  return udpApi.get('positions', {params: data});
};
